import { render } from "./Receptie.vue?vue&type=template&id=19ed550e&scoped=true"
import script from "./Receptie.vue?vue&type=script&lang=js"
export * from "./Receptie.vue?vue&type=script&lang=js"

import "./Receptie.vue?vue&type=style&index=0&id=19ed550e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ed550e"]])

export default __exports__